import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';

import { KpiEnum } from '../../../enums';

import { ConfigState, GetterClass } from '../../../models';

import { CONFIG_CONSTS } from '../../../store/config/config.consts';

export class KpisGetter implements GetterClass {

  public static execute(state: ConfigState, getters: any): KpiEnum[] {
    const instanceConfig: Instance = getters[CONFIG_CONSTS.getters.currentInstance];
    if (!!instanceConfig && !!instanceConfig.kpis) {
      return instanceConfig.kpis.reduce((supportedKpis: KpiEnum[], instanceConfigKpi: string) => {
        const kpi = ((instanceConfigKpi === 'noResults') ? KpiEnum.NO_RESULTS : instanceConfigKpi); // TODO: avoid Enum translate
        if ((Object.values(KpiEnum) as string[]).includes(kpi)) {
          supportedKpis.push((kpi as KpiEnum));
        }
        return supportedKpis;
      }, []);
    }
    return [];
  }

}
